import { LinkOutlined } from '@ant-design/icons';
import { Button } from '@g2u/ui-kit';
import { type ChatActionHandler } from './types';

export const MsgTlAction: ChatActionHandler = {
  type: 'MSG_TL',
  render: (payload) => {
    if (!payload?.msg) return null;
    return (
      <Button.$
        dataTestId="ai-action-msg-tl"
        type={Button.Type.Primary}
        size={Button.Size.Small}
        icon={<LinkOutlined />}
        href={payload.msg}
        target="_blank"
      >
        Message TL
      </Button.$>
    );
  },
};
